<div class="container">
    <div class="section-title">
        <h2>{{'main_title_about' | translate}}</h2>
        <div class="bar"></div>
        <p>{{'sub_title_about' | translate}}</p>
    </div>

    <div class="row align-items-center">
        <div class="col-lg-6 col-md-12">
            <div class="about-content">
                <h3>{{'about_heading' | translate}}</h3>
                <div class="bar"></div>
                <p>{{'about_1' | translate}}</p>
                <p>{{'about_2' | translate}}</p>
                <h5>{{'about_downloadnow' | translate}}</h5>
                <div class="about-btn">
                    <!-- <a routerLink="/new-quest" class="default-btn">Đến ngay<span></span></a> -->
                    <!-- <a href="#blog" class="default-btn">Đến ngay<span></span></a> -->
                    <!-- Custome for home-two  -->
                <!-- <div class="banner-holder">
                    <a routerLink="/"><img src="assets/img/store/1.png" class="img_chplay" alt="image"></a>
                    <a routerLink="/"><img src="assets/img/store/2.png" class="img_appstore" alt="image"></a>
                </div>
                <br> -->
                <div class="app-download-content">
                    <div class="app-holder">
                        <a routerLink="/"><img src="assets/img/store/1.png" alt="image"></a>
                        <a routerLink="/"><img src="assets/img/store/2.png" alt="image"></a>
                    </div>
                </div>

                </div>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="about-image">
                <!-- <img src="assets/img/about.png" alt="image"> -->
                <img src="assets/img/Q1.jpg" alt="image">
            </div>
        </div>
    </div>
</div>
